import { EarnDetailsAsset, EarnModel } from '../types'

export interface UseEarnDetailsDataHandlers {
  onDeposit: (asset: EarnDetailsAsset) => void
  onWithdraw: (asset: EarnDetailsAsset) => void
}

export const EARN_DETAILS_STATE = {
  LOADING: 'LOADING',
  NOT_FOUND: 'NOT_FOUND',
  READY: 'READY',
} as const

export type EarnDetailsState = (typeof EARN_DETAILS_STATE)[keyof typeof EARN_DETAILS_STATE]

export interface EarnDetailsDataCommon {
  isStatisticsLoading: boolean
  earnModel: EarnModel
  portfolioId: string | undefined
}

export interface EarnDetailsDataLoading {
  detailsState: typeof EARN_DETAILS_STATE.LOADING
}

export interface EarnDetailsDataNotFound {
  detailsState: typeof EARN_DETAILS_STATE.NOT_FOUND
}

export interface EarnDetailsDataReady {
  detailsState: typeof EARN_DETAILS_STATE.READY
  asset: string
  walletId: string
  epcTakesEarn: boolean
  earnRate: string
  customerEarnRate: string
  summary: {
    allocatedFunds: string
    unallocatedFunds: string
  }
  totalEarnings: {
    allocationEarnings: string
    customerEarnings: string
    totalEarnings: string
  }
  customerSummary: {
    customerEarningBalance: string
    customerUnpaidAmount: string
    customerPaidAmount: string
  }
  onDeposit: () => void
  onWithdraw: () => void
}

export type EarnDetailsData = EarnDetailsDataCommon &
  (EarnDetailsDataLoading | EarnDetailsDataNotFound | EarnDetailsDataReady)
